import 'jquery-validation';
import Utils from '../../util/utils';
const PromotionForm = {
  _jForm: $('.jsPromotionForm'),
  email: '',
  init() {
    this.initValidations();
    jQuery.validator.addMethod(
      'onlynumber',
      function (value, element) {
        return this.optional(element) || /^-?\d*$/i.test(value);
      },
      'Please provide only number.'
    );
  },
  initValidations() {
    const me = this;
    if (this._jForm.length > 0) {
      var config = Utils.getValidationConfig({
        ignore: [],
        rules: {
          your_name: {
            required: true,
            minlength: 2,
          },
          your_industry: {
            required: true,
            minlength: 2,
          },
          your_employee_count: {
            required: true,
            onlynumber: true,
          },
          your_email: {
            required: true,
            customemail: true,
          },

          our_existing_website: {
            required: true,
          },
        },
        messages: {
          your_name: {
            required: 'Please provide your name',
            minlength: 'Please provide your complete Name',
          },
          your_industry: {
            required: 'Please provide your Industry name',
            minlength: 'Please provide your complete Industry Name',
          },

          your_employee_count: {
            required: 'Please provide total employee',
          },
          your_email: {
            required: 'Please provide your e-mail address',
            customemail: 'Please provide a valid e-mail address',
          },
          our_existing_website: {
            required: 'Please provide your existing website',
          },
        },
        submitHandler: function () {
          me.onFormSubmit();
        },
      });
      this._jForm.validate(config);
    }
  },
  onFormSubmit() {
    if (this._jForm.valid()) {
      var $form = this._jForm;
      var unindexed_array = $form.serializeArray();
      var indexed_array = {};
      jQuery.map(unindexed_array, function (n) {
        indexed_array[n['name']] = n['value'];
      });
      var formData = {};
      formData = indexed_array;
      // formData.form_type = 'plans_from';
      Utils.sendRequest({
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'getContactForm',
          formData: formData,
        },
        onDone: $.proxy(this._onSuccess, this),
      });
    }
    return false;
  },
  _onSuccess() {
    this._jForm[0].reset();
    Utils.showLoader(true);
  },
};
export default PromotionForm;



// WEBPACK FOOTER //
// ./scripts/modules/forms/promotion_form.js